import type { SoldCostsHeld } from "./api";

export type MonthState = "held" | "waiting" | "history" | "open" | "closed";
type Flags = { held?: boolean; waiting_for_sheet?: boolean; history?: boolean; closed?: boolean };

export function monthState(x: Flags): MonthState {
  if (x.held) return "held";
  if (x.waiting_for_sheet) return "waiting";
  if (x.history) return "history";
  return x.closed === false ? "open" : "closed";
}

export const MONTH_STATE_COPY = {
  waiting: "Waiting for the sheet",
  waitingTitle: "Excludes Cost of Product: the Unified sheet has no rows for this month yet.",
  historyTitle: "No PFC close for this month: only cost of goods is computed, no fulfilment fees.",
} as const;

export function heldFor(held: SoldCostsHeld[] | undefined, entityId: string, month: string): SoldCostsHeld | undefined {
  return held?.find((entry) => entry.entity_id === entityId && entry.month.slice(0, 7) === month.slice(0, 7));
}

export function stateTitle(x: Flags): string {
  const parts: string[] = [];
  if (x.waiting_for_sheet) parts.push(MONTH_STATE_COPY.waitingTitle);
  if (x.history) parts.push(MONTH_STATE_COPY.historyTitle);
  return parts.join(" ");
}
